import { render, staticRenderFns } from "./LoginCompanyForm.vue?vue&type=template&id=3b6395e3"
import script from "./LoginCompanyForm.vue?vue&type=script&lang=ts"
export * from "./LoginCompanyForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports